<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <li>
            <router-link
              to="/"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li>
            <router-link
              to="/"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>
      </div>
    </nav>

    <!-- 新增投保导航栏 -->
    <div class="insurance-nav" style="bottom:0; top:auto; border-top:1px solid #eee">
      <div class="container">
        <!-- 左侧导航路径 -->
<!--        <div class="nav-left">-->
<!--          <router-link to="/product" class="back-link">产品</router-link>-->
<!--          <span class="divider">/</span>-->
<!--          <span>{{ product.title }}</span>-->
<!--        </div>-->
        <!-- 右侧投保按钮 -->
        <div class="nav-right">
          <button class="insure-btn" @click="showInsureModal = true">立即投保</button>
        </div>
      </div>
    </div>

    <!-- 投保确认弹窗 -->
    <div class="modal-mask" v-show="showInsureModal" @click.self="showInsureModal = false">
      <div class="insure-modal">
        <h3>温馨提示</h3>
        <div class="modal-content">
          <p>您已进入投保流程：</p>
          <ul class="notice-list">
            请仔细阅读
            <span class="highlight-blue">投保须知</span>、
            <span class="highlight-blue">责任免除</span>、
            <span class="highlight-blue">保险条款</span>
            等信息
            本产品由<span class="company-red">中国大地财产保险股份有限公司</span>承保
            由广东广福宏宇保险经纪有限公司提供销售和协助理赔等保险服务
            为维护您的合法权益，您的操作将被记录
          </ul>
          <a href="#" class="notice-link">查看客户告知书</a>
        </div>
        <button
          class="confirm-btn"
          @click="confirmInsure"
        >确认投保</button>
      </div>
    </div>

    <!-- ... 原有导航栏结构 ... -->
    <main class="container product-detail">
      <div class="product-header">
        <h1 class="product-title">{{ product.title }}</h1>
        <img
          src="https://picsum.photos/800/600?random=1"
          alt="产品主图"
          class="product-main-image"
        >
      </div>

      <section class="description-section">
        <h2 class="section-title">产品详情描述</h2>
        <img
          src="https://picsum.photos/1200/800?random=2"
          alt="详细描述"
          class="detail-image"
        >
      </section>

      <section class="plan-section">
        <h2 class="section-title">保障方案说明</h2>
        <img
          src="https://picsum.photos/1200/800?random=3"
          alt="方案描述"
          class="plan-image"
        >
      </section>

      <!-- 新增免责声明 -->
      <p class="disclaimer">本页面仅供参考，具体保险责任内容以保险公司正式签发的保险合同为准。</p>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2025 广东广福宏宇保险经纪有限公司 粤ICP备2025485413号-1 服务及投诉电话：400-867-5672</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>

  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  data () {
    return {
      showInsureModal: false, // 投保确认弹窗
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showLoginModal: false, // 登录模态框显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      product: {
        title: '健康医疗保险计划',
        // 使用稳定测试图片链接（保险相关示意图）
        mainImage: 'https://picsum.photos/800/600?random=1', // 主图尺寸 800x600
        detailImage: 'https://picsum.photos/1200/800?random=2', // 条款详情 1200x800
        planImage: 'https://picsum.photos/1200/800?random=3' // 保障方案 1200x800
      }
    }
  },
  methods: {
    // 新增确认投保方法
    confirmInsure () {
      this.showInsureModal = false
      this.$router.push('/insure-process') // 跳转到投保流程页
    },

    goBack () {
      this.$router.go(-1)
    },
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped>
/* 复用现有导航样式 */
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1;                /* 内容区域自动扩展占据剩余空间 */
}
/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto;       /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 80px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}

/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .back-to-top {
    bottom: 60px;  /* 移动端同步上移 */
    right: 15px;
  }
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}
/**图片*/
.product-detail {
  padding: 100px 20px 60px;
}

.product-header {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 50px;
}

.product-title {
  font-size: 2.2rem;
  color: #2c3e50;
  text-align: center;
}

.product-main-image {
  width: 100%;
  height: 400px; /* 固定高度 */
  object-fit: cover; /* 保持图片比例 */
  margin: 0 auto;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.section-title {
  font-size: 1.8rem;
  color: #3498db;
  margin: 40px 0 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #eee;
}

.detail-image,
.plan-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 20px 0;
}

.back-button {
  display: block;
  width: 200px;
  margin: 40px auto;
  padding: 12px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background 0.3s;
}

.back-button:hover {
  background: #2980b9;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .product-title {
    font-size: 1.8rem;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .product-header {
    margin-bottom: 30px;
  }

  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}

/* 第二个投保导航栏样式 */
.insurance-nav {
  position: fixed;
  height: 40px; /* 减小高度 */
  width: 100%;
  background: #f8f9fa;
  padding: 12px 0;
  z-index: 999;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  bottom: 0;  /* 固定到底部 */
  top: auto;   /* 覆盖原有top定位 */
  height: 50px; /* 适当增加高度 */
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
}

/* 为内容区域增加底部间距 */
.product-detail {
  padding: 80px 20px 200px; /* 底部padding加大 */
}

.insurance-nav .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.nav-right {
  margin-left: auto; /* 确保按钮靠右 */
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
}

.back-link {
  color: #3498db;
  text-decoration: none;
  transition: opacity 0.3s;
}

.back-link:hover {
  opacity: 0.8;
}

.divider {
  color: #666;
  margin: 0 4px;
}

.insure-btn {
  background: #1c9ef6;
  color: white;
  padding: 8px 24px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.insure-btn:hover {
  background: #c0392b;
}

/* 弹窗样式 */
/* 新增列表样式 */
.insure-modal h3 {
  color: red; /* 温馨提示标题红色 */
}

.highlight-blue {
  color: #3498db; /* 使用项目主蓝色 */
}
.company-red {
  color: #e74c3c;
  font-weight: 500;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.insure-modal {
  background: white;
  padding: 24px;
  border-radius: 8px;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-content {
  margin: 20px 0;
  line-height: 1.6;
}

.modal-content ul {
  margin: 15px 0;
  padding-left: 20px;
}

.notice-link {
  display: block;
  margin-top: 15px;
  color: #3498db;
  text-decoration: none;
}

.modal-close {
  display: block;
  margin-top: 20px;
  padding: 8px 20px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
/* 确认按钮样式 */
.confirm-btn {
  display: block;
  width: 120px;
  margin: 20px auto;
  padding: 10px 20px;
  background: #27ae60;
  color: white;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: background 0.3s;
}

.confirm-btn:hover {
  background: #219a52;
}

@media (max-width: 768px) {
  .product-main-image {
    height: 250px; /* 移动端缩小高度 */
  }
  .product-detail {
    padding-bottom: 120px;
  }
  .insurance-nav {
    height: 45px;
    padding: 8px 0;
  }

  .nav-left {
    font-size: 14px;
  }

  .insure-btn {
    padding: 6px 16px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/prodeuctItem.vue